import { captureException } from "@sentry/browser";
import SystemOneApp from "common/SystemOneApp";
import { Message } from "semantic-ui-react";
import React, { useEffect } from "react";
import { useRouteError } from "react-router";

export function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    captureException(error);
  }, []);

  return <SystemOneApp>
    <Message color="red">
      <span dangerouslySetInnerHTML={{ __html: RESX.ExceptionMessage.ThereWasAnError }} />
    </Message>
  </SystemOneApp>
}
